export const PaymentErrorCode = Object.freeze({
  CAPTURE_DECLINED: "capture_declined",
  ELEMENT_NOT_CREATED: "element_not_created",
  ELEMENT_READY_TIMEOUT: "element_ready_timeout",
  NO_CARD_INFO: "no_card_info",
});

export class PaymentError extends Error {
  constructor(message, details, code) {
    super(message);
    this.details = details;
    this.code = code;
  }

  static failed(error) {
    return new PaymentError("Payment failed", error?.message, error?.code);
  }
}
